module.exports = __webpack_public_path__ + "img/git-branch.9a8c65ef.svg";